import { Globe } from "lucide-react";
import { LOGO_URL, CONTACTS } from "@/data/site";

export const Footer = () => {
  return (
    <footer className="relative bg-ink-900 border-t border-white/10 pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Trinity Musical School" className="h-16 w-auto object-contain rounded-md" />
              <div>
                <div className="font-serif text-xl text-white">Trinity Musical School</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-gold-500">
                  Amici per la Musica APS
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-gray-400 max-w-sm">
              Scuola di musica e spettacolo con certificazioni internazionali London
              Trinity College. Centro esami ufficiale n° {CONTACTS.centre}.
            </p>
          </div>

          <div className="md:col-span-3">
            <h5 className="text-xs uppercase tracking-widest text-gold-500 mb-5">Contatti</h5>
            <ul className="space-y-3 text-sm text-gray-400">
              {CONTACTS.phones.map((p) => (
                <li key={p.link}>
                  <a href={`tel:${p.link}`} className="hover:text-gold-500 transition-colors duration-200">
                    {p.display} · {p.label}
                  </a>
                </li>
              ))}
              {CONTACTS.mobiles.map((m) => (
                <li key={m.link}>
                  <a href={`tel:${m.link}`} className="hover:text-gold-500 transition-colors duration-200">
                    Cell. {m.display}
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${CONTACTS.email}`} className="hover:text-gold-500 transition-colors duration-200">
                  {CONTACTS.email}
                </a>
              </li>
              <li className="pt-2">
                <a
                  href="https://www.trinitymusicalschool.net"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1.5 hover:text-gold-500 transition-colors duration-200"
                >
                  <Globe size={14} /> trinitymusicalschool.net
                </a>
              </li>
              <li>
                <a
                  href="https://www.amiciperlamusica.org"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1.5 hover:text-gold-500 transition-colors duration-200"
                >
                  <Globe size={14} /> amiciperlamusica.org
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h5 className="text-xs uppercase tracking-widest text-gold-500 mb-5">Sedi & legale</h5>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>APS Amici per la Musica – Trinity Musical School</li>
              <li>Riva del Po: Piazza Mazzini 14, loc. Ro (FE)</li>
              <li>Polesella: Piazza Matteotti 112 (RO)</li>
              <li>Rovigo: Via Luigi Einaudi 16 – Area Tosi (RO)</li>
              <li>C.F. 93101090384</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Amici per la Musica APS. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-gray-500">
            Accreditata Regione Emilia-Romagna e Regione Veneto · Quote detraibili nel 730
          </p>
        </div>
      </div>
    </footer>
  );
};
